import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown,
} from '../../common/form/FieldHelper';

class TransactionStatusDropdown extends Component {
  render() {
    const {
      name,
      form,
      searchFn,
      multiple,
      preload = true,
      included_status = [],
      valueField = 'id',
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType="transaction_status"
          type="transaction_status"
          valueField={valueField}
          preload={preload}
          component={
            multiple ? renderSearchMultipleDropdown : renderSearchDropDown
          }
          searchParams={{
            included: included_status,
          }}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(TransactionStatusDropdown);
